import { delay, fork, select } from "redux-saga/effects";
import { call, put } from "redux-saga/effects";
import { selectUser } from "../../features/auth/authSlice";
import { User } from "../../types/User";
import { Bookmark } from "../../types/Bookmark";
import {
  setError as setDashError,
  setStatus as setDashStatus,
} from "../../features/library/librarySlice";
import * as actions from "../actions";

import {
  apiCreateBookmark,
} from "../../services/BookmarkAPI";

export function* createBookmark(
    action: ReturnType<typeof actions.createBookmark>
    ) {
    yield put(setDashStatus({ status: "loading", error: undefined }));

    try {
        const userState = (yield select(selectUser)) as User;
        const createResponse = yield call(
            apiCreateBookmark,
            userState.default_organization_id,
            userState.default_workspace_id,
            action.payload
            );

        yield put(actions.getWorkspace(userState.default_workspace_id));

    } catch (e) {
        yield put(setDashError(String(e)));
        return;
    }
}